export default "__VITE_ASSET__9Fh2Htzd__"